import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { UtilsService } from '../../shared/utils-service';
import { MenuComponent } from '../../menu/menu.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
  providers: [MenuComponent]
})
export class ChangePasswordComponent implements OnInit {
private loader: boolean= false;
  password: any = {};
  private changepasswordurl: string = this.utils.url+"/ddmf_backoff/pwdAdmin?";
  loggedInUser: any = {};
  constructor(private http: Http, private router: Router, private matSnackBar: MatSnackBar, private utils: UtilsService, private menuComponent: MenuComponent) {
    this.loggedInUser = this.utils._checkSession();
  }

  ngOnInit() {
  }
  
  changePassword($event,password){
    if (password.newPassword && password.confirmPassword) {
      //DDMF-101 if condition added for alpha numeric validation in Reset password srceen
      if(!this.utils.validatePassword(password.newPassword) || !this.utils.validatePassword(password.confirmPassword)){
        this.utils.notify('Password must be minimum of 8 characters with alpha numeric and special character!', 'Close');
      }
      else{
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('userId', this.loggedInUser.userId);
        headers.append('token', this.loggedInUser.token);
            let pwdURL = '';
            let userid = this.loggedInUser.userId;
           /* if( this.loggedInUser.groupId == 30){
              userid = this.password.userId;
            }*/
            console.log(userid,pwdURL);
            pwdURL = this.changepasswordurl;
            this.loader=true;
             this.http.post(pwdURL,JSON.stringify({"userId": userid,
              "newpasswd": password.newPassword,
              "confirmNewPasswd": password.confirmPassword,
              "admResetPwd":false}), { headers: headers }).subscribe(res => {
              this.loader=false;
               var message = res['_body'];
               this.utils.notify(message);
                //this.matSnackBar.open(message, 'Close', {
                  //duration: 5000,
                //});

                
                //DDMF-101 : Start-Redirect after resetting password
                if(this.loggedInUser.firstTimeLoginInd=='Y'){
                this.loggedInUser.firstTimeLoginInd='N';

                sessionStorage.setItem('logged_in_user', JSON.stringify(this.loggedInUser));
                this.menuComponent.showMenu();

                let home={"router":"home", "menuName":"Home", "menuOrder":"0"};
                 var menu=this.loggedInUser.listGroupMenus;
                 if(this.loggedInUser.listGroupMenus.length==5){
                 menu.unshift(home);
                 }
                var page= "/"+menu[0].router;
                this.router.navigateByUrl(page);

                }
                //DDMF-101 : End-Redirect after resetting password


                let homeUrl = '/home';
                if (this.loggedInUser.groupName != 'Admin User') homeUrl = '/manage-users';
                 // this.router.navigateByUrl(homeUrl);
            }, error => {
            this.loader=false;
              console.log(error, 'error');
                 var message = error['_body'];
                 this.utils.notify(message);
                  //this.matSnackBar.open(message, 'Close', {
                 // duration: 5000,
                //});
            });
      }
       
  	} else {
  	this.utils.notify('All fields are mandatory !!', 'Close');
      ///this.matSnackBar.open('All fields are mandatory !!', 'Close', {
        //duration: 5000,
      //});
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/manage-users/change-password/change-password.component.ts